export default __webpack_public_path__ + "static/media/Patagonia.45c6cb16.png";